<template>
  <div>
    <WebIcon
      class="cursor-pointer text-neutral-900"
      name="XClose"
      size="xs"
    />
  </div>
</template>

<script setup lang="ts">
import WebIcon from '@zotlo-shared/components/icon/index.vue';
</script>
